import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import WorkIcon from "@mui/icons-material/Work";
import CategoryIcon from "@mui/icons-material/Category";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import PaymentIcon from '@mui/icons-material/Payment';
import ServiceMain from "./components/serviceList/serviceMain";
import BookingDetails from "./components/bookingDetails/bookingDetails";
import ServiceManscreen from "./components/serviceMan/serviceMan";
import BookingAdd from "./components/bookingAdd/bookingAdd";
import BusinessCategory from "./components/businessCategory/businessCategory";
import BusinessPaymentReport from "./components/businessPaymentReport/businessPaymentReport";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};

const Tabpanels = ({ franchiseId, setEditing }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="icon label tabs example"
        TabIndicatorProps={{
          style: {
            backgroundColor: "#ff4d4d",
          },
        }}
      >
        <Tab
          icon={<CategoryIcon />}
          iconPosition="start"
          label="Category Details"
        />
        <Tab
          icon={<FormatListBulletedIcon />}
          iconPosition="start"
          label="Service List"
        />
        {/* <Tab
          icon={<BookOnlineIcon />}
          iconPosition="start"
          label="Booking Details"
        /> */}
        <Tab
          icon={<ManageAccountsIcon />}
          iconPosition="start"
          label="Technician Details"
        />
        <Tab 
        icon={<WorkIcon />} 
        iconPosition="start" 
        label="Bookings" />

        <Tab
          icon={<PaymentIcon />}
          iconPosition="start"
          label="Payment Report"
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <BusinessCategory franchiseId={franchiseId} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ServiceMain franchiseId={franchiseId} />
      </TabPanel>
      {/* <TabPanel value={value} index={2}>
        <BookingDetails franchiseId={franchiseId} />
      </TabPanel> */}
      <TabPanel value={value} index={2}>
        <ServiceManscreen franchiseId={franchiseId} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <BookingAdd franchiseId={franchiseId} setEditing={setEditing} />
      </TabPanel>

      <TabPanel value={value} index={4}>
        <BusinessPaymentReport franchiseId={franchiseId} />
      </TabPanel>
    </>
  );
};

export default Tabpanels;
